import { Configuration } from "@socotec.io/atm-back-sdk";
import { useOidcStore } from "vue3-oidc";

export const atmBackConfiguration = new Configuration({
  basePath: import.meta.env.VITE_APP_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
});
